import React, { PureComponent } from "react";
import "./index.css";
import LoadMore from "../../components/LoadMore";
import { Container, Row, Col } from "reactstrap";

class InfoCard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <Row className="info-card-container">
        <Col className="info-card-left" lg="6" md="12">
          <div className="info-card-left-tittle">
            Shqiperia, nje vend demokratik
          </div>
          <div className="info-card-left-boddy">
            Me nje fjale demokracia duhet te jete udhëheqje E popullit, NGA
            populli dhe PËR popullin. Qe te realizohet forma demokratike ne nje
            shtet, nuk mjafton vetem mirefunksionimi i strukturave dhe
            mekanizmave institucionale, por duhet te vendoset nje raport i
            ndersjellte i shtetasve dhe shoqerise me shtetin. Nje shtet mund te
            arrije te demokratizohet, ne rast se edhe shtetasit e tij e duan dhe
            kontribuojne ne kete proces. Ashtu si individi qe mund te prishe
            rregullin dhe shtetin, ashtu dhe shteti mund te demtoje individin.
            Fatkeqesisht ne realitetin tone ndodhin te dyja...{" "}
          </div>
          <div className="info-card-link">
            <LoadMore />
          </div>
        </Col>
        <Col className="info-card-photo" lg="6" md="12">
          <img
            src="https://balkanweb.com/wp-content/uploads/2018/05/komisioni-i-ligjeve-sot.jpg"
            alt=""
          />
        </Col>
      </Row>
    );
  }
}

InfoCard.propTypes = {};

export default InfoCard;
